(()=>{
  const storageGet=key=>{
    try{return sessionStorage.getItem(key)}catch(e){return null}
  }

  const storageSet=(key,value)=>{
    try{sessionStorage.setItem(key,value)}catch(e){}
  }

  const hideSwitcher=root=>{
    if(!root)return
    const panel=root.querySelector('[data-aph-mood-panel]')
    const toggle=root.querySelector('[data-aph-mood-toggle]')
    if(panel)panel.hidden=true
    if(toggle)toggle.setAttribute('aria-expanded','false')
    document.body.classList.remove('aph-mood-open')
    root.hidden=true
    root.setAttribute('aria-hidden','true')
    root.style.setProperty('display','none','important')
    storageSet('ad-mood-switcher-dismissed','1')
  }

  const initRoot=root=>{
    if(!root||root.dataset.aphMoodEnhancements==='true')return
    root.dataset.aphMoodEnhancements='true'

    const options=[...root.querySelectorAll('[data-aph-mood-option]')]
    const logos=[...document.querySelectorAll('[data-aph-mood-logo]')]

    if(storageGet('ad-mood-switcher-dismissed')==='1'){
      hideSwitcher(root)
      return
    }

    if(storageGet('aph-mood-logo-session-active')!=='1'){
      logos.forEach(logo=>{
        const defaultLogo=logo.dataset.logoDefault
        if(defaultLogo&&logo.getAttribute('src')!==defaultLogo)logo.src=defaultLogo
      })
    }

    options.forEach(button=>{
      button.addEventListener('click',()=>{
        storageSet('aph-mood-logo-session-active','1')
      })
    })
  }

  const init=scope=>{
    const roots=[...(scope||document).querySelectorAll?.('[data-aph-mood-switcher]')||[]]
    if(scope?.matches?.('[data-aph-mood-switcher]'))roots.unshift(scope)
    if(!roots.length){
      const root=document.querySelector('[data-aph-mood-switcher]')
      if(root)roots.push(root)
    }
    roots.forEach(initRoot)
  }

  document.addEventListener('click',event=>{
    const dismiss=event.target.closest?.('[data-aph-mood-dismiss]')
    if(!dismiss)return
    const root=dismiss.closest('[data-aph-mood-switcher]')
    if(!root)return
    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()
    hideSwitcher(root)
  },true)

  document.addEventListener('pointerdown',event=>{
    const dismiss=event.target.closest?.('[data-aph-mood-dismiss]')
    if(!dismiss)return
    event.stopPropagation()
  },true)

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',()=>init(document),{once:true})
  }else{
    init(document)
  }

  document.addEventListener('shopify:section:load',event=>init(event.target))
})()

(() => {
  const storageKey = 'ad-mood-switcher-position-v1';

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const init = (scope = document) => {
    const roots = [];

    if (scope.matches?.('[data-aph-mood-switcher]')) {
      roots.push(scope);
    }

    scope.querySelectorAll?.('[data-aph-mood-switcher]').forEach((root) => {
      if (!roots.includes(root)) roots.push(root);
    });

    roots.forEach((root) => {
      if (root.dataset.aphDragBound === 'true') return;

      const trigger = root.querySelector('[data-aph-mood-toggle]');
      const panel = root.querySelector('[data-aph-mood-panel]');

      if (!trigger) return;

      root.dataset.aphDragBound = 'true';
      root.dataset.aphDraggable = 'true';

      let startX = 0;
      let startY = 0;
      let originX = 0;
      let originY = 0;
      let dragging = false;
      let pointerId = null;
      let suppressClick = false;

      const updateDirection = () => {
        const rect = root.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;

        root.classList.toggle('is-drag-left', centerX < window.innerWidth / 2);
        root.classList.toggle('is-drag-right', centerX >= window.innerWidth / 2);
        root.classList.toggle('is-drag-bottom', centerY > window.innerHeight * .58);
      };

      const setPosition = (x, y, save = false) => {
        const rect = root.getBoundingClientRect();
        const width = rect.width || trigger.offsetWidth || 44;
        const height = rect.height || trigger.offsetHeight || 44;
        const margin = 10;

        const nextX = clamp(
          x,
          margin,
          Math.max(margin, window.innerWidth - width - margin)
        );

        const nextY = clamp(
          y,
          margin,
          Math.max(margin, window.innerHeight - height - margin)
        );

        root.style.setProperty('left', `${nextX}px`, 'important');
        root.style.setProperty('top', `${nextY}px`, 'important');
        root.style.setProperty('right', 'auto', 'important');
        root.style.setProperty('bottom', 'auto', 'important');

        root.dataset.aphDragged = 'true';

        updateDirection();

        if (save) {
          try {
            sessionStorage.setItem(
              storageKey,
              JSON.stringify({
                x: nextX,
                y: nextY
              })
            );
          } catch (error) {}
        }
      };

      const restorePosition = () => {
        try {
          const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');

          if (
            saved &&
            Number.isFinite(Number(saved.x)) &&
            Number.isFinite(Number(saved.y))
          ) {
            requestAnimationFrame(() => {
              setPosition(Number(saved.x), Number(saved.y), false);
            });
          }
        } catch (error) {}
      };

      trigger.addEventListener('pointerdown', (event) => {
        if (event.button !== undefined && event.button !== 0) return;
        if (panel && panel.hidden === false) return;

        const rect = root.getBoundingClientRect();

        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        originX = rect.left;
        originY = rect.top;
        dragging = false;

        try {
          trigger.setPointerCapture(pointerId);
        } catch (error) {}
      });

      trigger.addEventListener('pointermove', (event) => {
        if (pointerId === null || event.pointerId !== pointerId) return;

        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;

        if (!dragging) {
          if (Math.hypot(deltaX, deltaY) < 7) return;

          dragging = true;
          root.classList.add('is-dragging');
        }

        event.preventDefault();

        setPosition(
          originX + deltaX,
          originY + deltaY,
          false
        );
      });

      const finishDrag = (event) => {
        if (pointerId === null) return;
        if (event.pointerId !== undefined && event.pointerId !== pointerId) return;

        try {
          trigger.releasePointerCapture(pointerId);
        } catch (error) {}

        if (dragging) {
          const rect = root.getBoundingClientRect();

          setPosition(rect.left, rect.top, true);

          suppressClick = true;
          root.classList.remove('is-dragging');
        }

        dragging = false;
        pointerId = null;
      };

      trigger.addEventListener('pointerup', finishDrag);
      trigger.addEventListener('pointercancel', finishDrag);

      trigger.addEventListener(
        'click',
        (event) => {
          if (!suppressClick) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          suppressClick = false;
        },
        true
      );

      window.addEventListener(
        'resize',
        () => {
          if (root.dataset.aphDragged !== 'true') return;

          const rect = root.getBoundingClientRect();
          setPosition(rect.left, rect.top, true);
        },
        { passive: true }
      );

      restorePosition();
      updateDirection();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();